import { RENTALS, isRental } from "../../../helpers/rentals";
import customOrderCategories from "./customOrderCategories.json";

const requiresInfoData = {
  ski: ["height", "foot"],
  snowboard: ["height", "foot"],
  bootsApreski: ["foot"],
  bootsTrekking: ["foot"],
  bootsSnowboard: ["foot"],
  bootsSki: ["foot"],
  surfTables: ["height"],
  bundles: ["height", "foot"],
  shoes: ["foot"],
  bicycles: ["height"],
  trekkingSticks: ["height"],
  eBikes: ["height"],
  snowshoes: ["foot"],
  skiSticks: ["height"],
  splitboard: ["height", "foot"],
  bundle: ["height"],
};

export const config = {
  foot: {
    min: 11,
    max: 35,
  },
  height: {
    min: 90,
    max: 220,
  },
};

export const requiresInfo = (category, supplierId) => {
  if (
    (isRental(supplierId, RENTALS.travesiaCatedral) ||
      isRental(supplierId, RENTALS.fronteraSur) ||
      isRental(supplierId, RENTALS.windfly)) &&
    requiresInfoData[category]
  ) {
    return requiresInfoData[category].filter((info) => info !== "foot");
  } else {
    return requiresInfoData[category] ? requiresInfoData[category] : [];
  }
};

export const sortCategories = (categories) => {
  return categories.sort((a, b) => {
    const orderA = customOrderCategories[a] || Infinity;
    const orderB = customOrderCategories[b] || Infinity;
    return orderA - orderB;
  });
};

export const requiresVariant = (supplierId, productCategoryId) => {
  return (
    (isRental(supplierId, RENTALS.travesiaCatedral) ||
      isRental(supplierId, RENTALS.fronteraSur) ||
      isRental(supplierId, RENTALS.windfly)) &&
    requiresSizeVariant(productCategoryId)
  );
};

export const requiresSizeVariant = (productCategoryId) => {
  return (
    productCategoryId === "61b8b601e15a0c13a0d86cd4" ||
    productCategoryId === "61b8b3fb09e5c6139949f2ce" ||
    productCategoryId === "61b8b7c399d697140841c6f5"
  );
};
